import { render, staticRenderFns } from "./BossList.vue?vue&type=template&id=295a2130&"
import script from "./BossList.vue?vue&type=script&lang=ts&"
export * from "./BossList.vue?vue&type=script&lang=ts&"
import style0 from "./BossList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports